import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import ToolTip from '../../components/ToolTip';
import styles from './toolTips.css';

const ToolTips = ({ children }) => {
  const [toolTipActive, setToolTipActive] = useState(false);
  const [toolTipText, setToolTipText] = useState('');

  const handleMouseEvents = event => {
    const eventType = event.type;
    const el = event.target.closest('[data-tooltip]');

    if (el) {
      const footer = document.querySelector('.site-footer');

      if (eventType === 'mouseover' || eventType === 'focus') {
        footer.style.opacity = 0;
        setToolTipActive(true);
        setToolTipText(el.dataset.tooltip);
      } else if (eventType === 'mouseout' || eventType === 'blur') {
        footer.style.opacity = 1;
        setToolTipActive(false);
        setToolTipText('');
      }
    }
  };

  return (
    <div
      className={styles.wrapper}
      onFocus={handleMouseEvents}
      onBlur={handleMouseEvents}
      onMouseOver={handleMouseEvents}
      onMouseOut={handleMouseEvents}>
      {children}
      <CSSTransition
        mountOnEnter
        unmountOnExit
        in={toolTipActive}
        timeout={{ enter: 400, exit: 400 }}
        classNames={{
          enter: styles.fadeEnter,
          enterActive: styles.fadeEnterActive,
          exit: styles.fadeExit,
          exitActive: styles.fadeExitActive,
        }}>
        <ToolTip tipText={toolTipText} />
      </CSSTransition>
    </div>
  );
};

ToolTips.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ToolTips;
